import Inputs from "./Inputs";

export default Inputs;
